import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './auth/AuthProvider';
import { PermissionsProvider } from './contexts/PermissionsContext';
import { OperationsProvider } from './contexts/OperationsContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/common/ProtectedRoute';
import LoginPage from './pages/Login/LoginPage';
import DashboardPage from './pages/Dashboard/DashboardPage';
import PurchaseOrdersPage from './pages/PurchaseOrders/PurchaseOrdersPage';
import PurchaseOrderDetailPage from './pages/PurchaseOrders/PurchaseOrderDetailPage';
import ShipmentsPage from './pages/Shipments/ShipmentsPage';
import ShipmentDetailPage from './pages/Shipments/ShipmentDetailPage';
import InvoicesPage from './pages/Invoices/InvoicesPage';
import InvoiceDetailPage from './pages/Invoices/InvoiceDetailPage';
import ProductsPage from './pages/Products/ProductsPage';
import ProductDetailPage from './pages/Products/ProductDetailPage';
import InventoryPage from './pages/Inventory/InventoryPage';
import UsersPage from './pages/Users/UsersPage';
import PermissionsPage from './pages/Permissions/PermissionsPage';
import CompanyProfilePage from './pages/Settings/CompanyProfilePage';
import SyncLogsPage from './pages/Sync/SyncLogsPage';
import ReportsPage from './pages/Reports/ReportsPage';
import './App.css';

const App: React.FC = () => {
  return (
    <ThemeProvider>
    <AuthProvider>
      <BrowserRouter>
        <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} theme="colored" />
        <AuthenticatedTemplate>
          <PermissionsProvider>
            <OperationsProvider>
            <Layout>
              <Routes>
                <Route path="/" element={<ProtectedRoute module="Dashboard"><DashboardPage /></ProtectedRoute>} />
                <Route path="/purchase-orders" element={<ProtectedRoute module="PurchaseOrders"><PurchaseOrdersPage /></ProtectedRoute>} />
                <Route path="/purchase-orders/:id" element={<ProtectedRoute module="PurchaseOrders"><PurchaseOrderDetailPage /></ProtectedRoute>} />
                <Route path="/shipments" element={<ProtectedRoute module="Shipments"><ShipmentsPage /></ProtectedRoute>} />
                <Route path="/shipments/:id" element={<ProtectedRoute module="Shipments"><ShipmentDetailPage /></ProtectedRoute>} />
                <Route path="/invoices" element={<ProtectedRoute module="Invoices"><InvoicesPage /></ProtectedRoute>} />
                <Route path="/invoices/:id" element={<ProtectedRoute module="Invoices"><InvoiceDetailPage /></ProtectedRoute>} />
                <Route path="/products" element={<ProtectedRoute module="Products"><ProductsPage /></ProtectedRoute>} />
                <Route path="/products/:id" element={<ProtectedRoute module="Products"><ProductDetailPage /></ProtectedRoute>} />
                <Route path="/inventory" element={<ProtectedRoute module="Inventory"><InventoryPage /></ProtectedRoute>} />
                <Route path="/users" element={<ProtectedRoute module="Users"><UsersPage /></ProtectedRoute>} />
                <Route path="/permissions" element={<ProtectedRoute module="Users" requireWrite><PermissionsPage /></ProtectedRoute>} />
                <Route path="/settings/company" element={<ProtectedRoute module="Invoices" requireWrite><CompanyProfilePage /></ProtectedRoute>} />
                <Route path="/sync-logs" element={<ProtectedRoute module="Dashboard"><SyncLogsPage /></ProtectedRoute>} />
                <Route path="/reports" element={<ProtectedRoute module="Dashboard"><ReportsPage /></ProtectedRoute>} />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </Layout>
            </OperationsProvider>
          </PermissionsProvider>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <Routes>
            <Route path="*" element={<LoginPage />} />
          </Routes>
        </UnauthenticatedTemplate>
      </BrowserRouter>
    </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
